import React from "react";

import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import { toast } from 'react-toastify';

import SetPassword from "./SetPassword";

import { getURLParameter } from "UTILS/Utility";
import { getMessage } from "CONFIG/i18n";

import { setPasswordAction } from "CONFIG/ActionFactory";

import { connect } from "react-redux";

import { bindActionCreators } from "redux";

import setLanguageAction from "COMPONENTS/CommonComponents/ChangeLanguage/setLanguageAction";

// CONSTANTS
import { TIMEOUT } from "UTILS/Constants";

import "../ResetPassword/ResetPassword.less";
class SetPasswordContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      errorMessage: "",
      networkError: "",
      token: null,
      reset: false,
      admin: false,
      isPasswordSet: false
    };
  }

  componentDidMount() {
    let token = getURLParameter("token");
    let reset = getURLParameter("reset") ? true : false;
    let admin = getURLParameter("admin") ? true : false;
    if (!token) {
      this.displayError(getMessage("INVALID_LINK"));
    }
    this.setState({
      token: token,
      reset: reset,
      admin: admin
    });
  }

  handleSetPassword = (data, callback) => {
    data.token = this.state.token;
    setPasswordAction.setPasswordAction(data).then(
      () => {
        toastr.success(`${getMessage("PASSWORD_SET")}`);
        if (callback) callback({ resp: "success" });
        setTimeout(() => {
          if (this.state.admin) {
            this.props.history.push("/admin/login");
          } else {
            this.props.history.push("/");
          }
        }, TIMEOUT.SHORT);
      },
      error => {
        if (error.code === 'INVALID_TOKEN') this.displayError(getMessage("SET_PASSWORD_EXPIRED"));
        else {
          if (callback) callback({ resp: "error", error: error });
        }
      }
    );
  };

  displayError = message => {
    toastr.error(message);

    setTimeout(() => {
      this.props.history.push("/");
    }, TIMEOUT.SHORT);
  };

  render() {
    return (
      <div>
        {this.state.token ? (
          <SetPassword
            handleSetPassword={this.handleSetPassword}
            errorMessage={this.state.errorMessage}
            username={this.state.username}
            setLanguageAction={this.props.setLanguageAction}
            language={this.props.language}
            reset={this.state.reset}
          />
        ) : null}
      </div>
    );
  }

  componentWillUnmount() {
    //toast.removeByType("success");
    //toast.removeByType("error");
    toast.dismiss()
  }
}

const mapStateToProps = state => {
  return {
    language: state.LanguageReducer.language,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ setLanguageAction }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetPasswordContainer);
